var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiRsArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_885_2127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0003 13V11L2.55526 11.031L6.87726 6.70697L5.46326 5.29297L0.877261 9.87897C0.314847 10.4416 -0.00109863 11.2045 -0.00109863 12C-0.00109863 12.7955 0.314847 13.5584 0.877261 14.121L5.46326 18.707L6.87726 17.293L2.61526 13.031L24.0003 13Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_885_2127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRsArrowLeft);
export default __webpack_public_path__ + "static/media/fi-rs-arrow-left.53a0e5fa.svg";
export { ForwardRef as ReactComponent };